import './App.css';
import Presentation from './pages/Presentation'
import Development from './pages/Development'
import Trajectory from './pages/Trajectory'
import Socials from './components/Socials'
import './styles/Product.css'
import './styles/Development.css'
import './styles/Trajectory.css'
import React from 'react';

function App() {
	return (
		<div> 
			<Socials />
			<Presentation />
			<Development />
			<Trajectory />
		</div>
	);
}

export default App;
